


















































































































































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { State, Getter, Action, Mutation, namespace } from "vuex-class";
import {
  pagination,
  loadingCatch,
  loading,
  SearchbarControl,
  IsMore
} from "@root/lib/decorator";
import { productConditionFilter } from "@root/lib/common.ts";
import { getNowYYYYMMDDhhmmss, obj2Arr } from "@root/lib/utils";
const defaultImageLink = require("@/assets/image/default_product_image_v2.png");

const scan = namespace("scan");
const root = namespace("root");

@Component({
  components: {}
})
@pagination("getData", {
  pageSize: 50
})
@SearchbarControl()
@loading()
@IsMore(true)
export default class wtK1ScanCodeException extends Vue {
  data() {
    return {
      obj2Arr
    };
  }
  @root.State ddCodes;
  @scan.Action queryScanException;
  @scan.Action exportScanException;
  @scan.Action scanExceptionUpdateStatus;

  private form = {
    createTime: "",
    scanType: "",
    exceptionType: "",
    orgCode: "",
    tyreCode: "",
    parentOrgCode: ""
  };
  private tableData = [];
  private dataList = [];

  private scanTypeObj = {
    "3": "出库",
    "4": "退货",
    "5": "盘点"
  };
  statusObj(row) {
    let exceptionType = this.ddCodes.SCAN_EXCEPTION_MAP[row.exceptionType];
    if(!(exceptionType === "胎号不存在" || exceptionType === "渠道不匹配") || isNaN(row.status)){
      return "";
    }
    let statusObjs = {
      "0": "待审核",
      "1": "已通过",
      "2": "已拒绝",
      "3": "待提交"
    };
    return statusObjs[row.status];
  }
  // private searchParams = {};
  get searchParams() {
    let { createTime, ...others } = this.form;

    let start = undefined;
    let end = undefined;
    if (createTime) {
      start = createTime[0];
      end = createTime[1];
    }
    let input = {
      orgType: "1",
      ...others,
      startTime: start,
      endTime: end
    };
    return input;
  }

  async onAppeal(row) {
    await this.$confirm("你确定申诉吗？", "", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning"
    });
    await this.scanExceptionUpdateStatus({
      code: row.code,
      status: 0
    });
    await this.$message.success("成功");
    await this.getData();
  }

  async created() {
    // await this.getData();
    this.$dd.register(["SCAN_EXCEPTION"]).query();
  }

  @loadingCatch
  async getData() {
    const { pageSize, currentPage: pageNum } = this as any;
    const pageInput = {
      pageSize,
      pageNum
    };
    try {
      let input = this.searchParams;
      let { list, total } = await this.queryScanException({
        input,
        pageInput
      });
      this.dataList = list;
      (this as any).total = total;
      // this.searchParams = input;
    } catch (err) {
      console.error(err);
      (this as any).total = 0;
    }
  }
  handleExport() {
    (this.$refs.gtExportDialog as any).visible = true;
  }
  async exportExcelFn(params) {
    await this.exportScanException({
      input: this.searchParams,
      pageInput: {
        pageSize: (this as any).total,
        pageNum: 1
      }
    });
  }

  fImage(src) {
    return src || defaultImageLink;
  }
}
